module.exports = __webpack_public_path__ + "img/commerceB.3e251d0b.png";